var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB2BAdminChapterName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#CB202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.71 15.5462L20.21 12.5462C20.1442 12.5158 20.0725 12.5 20 12.5C19.9275 12.5 19.8558 12.5158 19.79 12.5462L13.29 15.5462C13.2032 15.5864 13.1298 15.6506 13.0784 15.7313C13.027 15.8119 12.9998 15.9056 13 16.0012V24.5012C12.9998 24.5969 13.027 24.6906 13.0784 24.7712C13.1298 24.8519 13.2032 24.9161 13.29 24.9562L19.79 27.9562C19.8558 27.9867 19.9275 28.0025 20 28.0025C20.0725 28.0025 20.1442 27.9867 20.21 27.9562L26.71 24.9562C26.7968 24.9161 26.8702 24.8519 26.9216 24.7712C26.973 24.6906 27.0002 24.5969 27 24.5012V16.0012C27.0002 15.9056 26.973 15.8119 26.9216 15.7313C26.8702 15.6506 26.7968 15.5864 26.71 15.5462ZM20 18.4512L14.695 16.0012L20 13.5512L25.305 16.0012L20 18.4512ZM26 24.1812L20.5 26.7212V19.3212L26 16.7812V24.1812Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BAdminChapterName);
export default __webpack_public_path__ + "static/media/B2BAdminChapterName.c39e86d167081279112ce9f9971ee4ac.svg";
export { ForwardRef as ReactComponent };